const chart = (labels = [], datasets = []) => {
  const newData = {
    labels,
    datasets,
  };
  return newData;
};

export default chart;
